// extracted by mini-css-extract-plugin
module.exports = {"slider":"TextCarousel_slider__1KtJr"};